module.exports = __webpack_public_path__ + "static/media/O49-2500_in.6413ce83.jpg";